export const envSuffix = ''
/**
 * @deprecated
 */
export const apiUrl = `//api${envSuffix}.prohabits.com`

export const apiUrlNew = `api${envSuffix}.prohabits.com`
export const apiVersion = 'v1'
export const apiEndpoint = apiUrl + '/' + apiVersion
export const protocol = 'https://'
export const socketsServerUrl = `api${envSuffix}.prohabits.com:8070`
export const googleAnalyticsTrackingID = 'UA-96877770-2'
export const sentryRavenLink = 'https://7318a9a861ff4304a1cf727085c1ac3e@sentry.io/275168'
export const locizeApiKey = '2b6b3284-8f86-4cec-8176-f6eefeff0a31'
export const locizeProjectId = '1ac33dbc-ae16-4824-a4a3-525d2a734f74'
